import actionTypes from './actionTypes';

const INITIAL_STATE = {
  notificationsList: [],

  getUnreadNotificationLoading: false,
  getUnreadNotificationFailed: false,
  getUnreadNotificationError: false,
  getUnreadNotificationMessage: null,

  putReadNotificationLoading: false,
  putReadNotificationFailed: false,
  putReadNotificationError: false,
  putReadNotificationMessage: null,
  updateSocketReserve: null,
  tabletPrintReq: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.PRINT_REQUEST_TABLET: {
      return {
        ...state,
        tabletPrintReq: action.payload,
      };
    }
    case actionTypes.UPDATE_SOCKET_RESERVE: {
      return {
        ...state,
        updateSocketReserve: action.payload,
      };
    }
    case actionTypes.NEW_RESERVE_SUBMITTED_NOTIFICATION: {
      return {
        ...state,
        notificationsList: [action.payload.message, ...state.notificationsList],
      };
    }
    case actionTypes.RESERVEـREQUESTS_AUTOMATICALLY_APPROVED_NOTIFICATION: {
      return {
        ...state,
        notificationsList: [action.payload.message, ...state.notificationsList],
      };
    }

    case actionTypes.GET_MY_UNREAD_NOTIFICATION_LOADING: {
      return {
        ...state,
        getUnreadNotificationLoading: true,
        getUnreadNotificationFailed: false,
        getUnreadNotificationError: false,
        getUnreadNotificationMessage: null,
        notificationsList: [...state.notificationsList],
      };
    }
    case actionTypes.GET_MY_UNREAD_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        getUnreadNotificationLoading: false,
        getUnreadNotificationFailed: false,
        getUnreadNotificationError: false,
        getUnreadNotificationMessage: null,
        notificationsList: [
          ...state.notificationsList,
          ...action.payload.notifications,
        ],
      };
    }
    case actionTypes.GET_MY_UNREAD_NOTIFICATION_FAILED: {
      return {
        ...state,
        getUnreadNotificationLoading: false,
        getUnreadNotificationFailed: true,
        getUnreadNotificationError: false,
        getUnreadNotificationMessage: action.payload,
        notificationsList: [...state.notificationsList],
      };
    }
    case actionTypes.GET_MY_UNREAD_NOTIFICATION_REJECT: {
      return {
        ...state,
        getUnreadNotificationLoading: false,
        getUnreadNotificationFailed: false,
        getUnreadNotificationError: true,
        getUnreadNotificationMessage: null,
        notificationsList: [...state.notificationsList],
      };
    }
    case actionTypes.PUT_READ_NOTIFICATION_LOADING: {
      return {
        ...state,
        putReadNotificationLoading: true,
        putReadNotificationFailed: false,
        putReadNotificationError: false,
        putReadNotificationMessage: null,
        notificationsList: [...state.notificationsList],
      };
    }
    case actionTypes.PUT_READ_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        putReadNotificationLoading: false,
        putReadNotificationFailed: false,
        putReadNotificationError: false,
        putReadNotificationMessage: null,
        notificationsList: [],
      };
    }
    case actionTypes.PUT_READ_NOTIFICATION_FAILED: {
      return {
        ...state,
        putReadNotificationLoading: false,
        putReadNotificationFailed: true,
        putReadNotificationError: false,
        putReadNotificationMessage: action.payload,
        notificationsList: [...state.notificationsList],
      };
    }
    case actionTypes.PUT_READ_NOTIFICATION_REJECT: {
      return {
        ...state,
        putReadNotificationLoading: false,
        putReadNotificationFailed: true,
        putReadNotificationError: true,
        getUnreadNotificationMessage: null,
        notificationsList: [...state.notificationsList],
      };
    }

    default: {
      return state;
    }
  }
};
